import React, { Component, Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { Switch, withRouter } from 'react-router-dom';
import { toggleProfile } from '../actions/user';
import StaffMenu from '../components/Navigation/StaffMenu';
import SSRStorage from '../services/storage';
import { USER_RECORD } from '../services/constants';
import Splash from '../components/Splash';
import HashRoute from '../components/HashRoute';
import StaffTopBar from '../components/Navigation/StaffTopBar';

const Profile = lazy(() => import('../components/Staff/Profile'));
const Attendance = lazy(() => import('../components/Staff/Attendance'));
const Leave = lazy(() => import('../components/Staff/Leave'));
const Payroll = lazy(() => import('../components/Staff/Payroll'));
const Transactions = lazy(() => import('../components/Staff/Transactions'));
const Appraisal = lazy(() => import('../components/Staff/Appraisal'));

const storage = new SSRStorage();

const Page = ({ location }) => {
	const hash = location.hash.substr(1);
	// const {  staff } = this.props;
	switch (hash) {
		case 'payroll':
			return <Payroll />;
		case 'transactions':
			return <Transactions />;
		case 'attendance':
			return <Attendance />;
		case 'leave':
			return <Leave />;
		case 'appraisals':
			return <Appraisal />;
		default:
			return <Profile />;
	}
};

class StaffProfile extends Component {
	state = {
		profile_image: null,
	};
	closeProfile = () => {
		storage.removeItem(USER_RECORD);
		this.props.toggleProfile(false);
	};

	componentDidMount() {
		const image = localStorage.getItem('STAFFIMAGE');
		this.setState({ profile_image: image });
		const { location } = this.props;
		if (!location.hash) {
			this.props.history.push(`${location.pathname}#profile`);
		}
	}

	componentWillUnmount() {
		const { location } = this.props;
		this.props.history.push(location.pathname);
	}

	onChange = async e => {
		const reader = new FileReader(),
			files = e.target.files;

		reader.onload = function () {
			localStorage.setItem('STAFFIMAGE', reader.result);
		};
		const image = await localStorage.getItem('STAFFIMAGE');
		localStorage.removeItem('STAFFIMAGE');
		await this.setState({ profile_image: image });
		reader.readAsDataURL(files[0]);
	};
	render() {
		const { profile_image } = this.state;

		const { location, staff, user } = this.props;
		return (
			<div className="layout-w">
				<button aria-label="Close" className="close custom-close" type="button" onClick={this.closeProfile}>
					<span className="os-icon os-icon-close" />
				</button>
				{staff ? (
					<div
						className="content-w"
						style={{
							width: 'calc(100% - 260px)',
							overflow: 'hidden',
							padding: '10px 0 20px 10px',
						}}
					>
						<div className="content-i">
							<div className="content-box">
								<div className="row">
									<div className="col-sm-12">
										<div className="element-wrapper">
											<div data-sr-id={2} style={{ visibility: 'visible', transform: 'none', opacity: 1, transition: 'none' }}>
												<StaffTopBar profileImage={profile_image} user={user} />
												<StaffMenu />
												<Suspense fallback={<Splash />}>
													<Switch>
														<HashRoute hash={location.hash} component={Page} />
													</Switch>
												</Suspense>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="content-w">
						<div className="top-bar color-scheme-transparent"></div>
						<div className="content-i">
							<div className="content-box text-center">
								<h5>Staff profile was not found</h5>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		staff: state.user.staff,
		user: state.user.profile,
	};
};

export default withRouter(connect(mapStateToProps, { toggleProfile })(StaffProfile));
